/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'baglass/core-client/js/core-client/utils/BrowserUtils',
	'gemini/lib/@waca/dashboard-common/dist/core/APIFactory',
	'gemini/lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI'
], function(_, BrowserUtils, APIFactory, PropertiesProviderAPI) {

	const SUPPORTED_REVEAL_VIS_TYPES = ['Line', 'Column', 'StackedColumn', 'Bar', 'StackedBar'];

	class RevealPropertiesProvider {
		constructor(options) {
			this.dashboardApi = options.dashboardAPI;
			this.content = options.content;
			this.stringResources = this.dashboardApi.getFeature('.StringResources');
			this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);
			// register self as a properties provider contributing storytelling RevealPropertiesProvider properties
			this.content.getFeature('Properties').registerProvider(this.getAPI());
		}

		getAPI() {
			return this._api;
		}

		getPropertyLayoutList(){
			if(!this._isVisTypeSupported() || !this._shouldShow()) {
				return [];
			}
			return [{
				id: 'animation',
				type: 'Group',
				label: this.stringResources.get('tabName_animation')
			},{
				id: 'propAniTypeDataEntrance',
				type: 'Section',
				label: this.stringResources.get('propAniTypeDataEntrance'),
				position: 0
			}];
		}

		getPropertyList() {
			if(!this._isVisTypeSupported() || !this._shouldShow()) {
				return [];
			}
			return this._getRevealPropertiesList();
		}

		_isVisTypeSupported() {
			return SUPPORTED_REVEAL_VIS_TYPES.indexOf(this._getVisType()) !== -1;
		}

		_getVisType() {
			return this.content.getFeature('Visualization').getType();
		}

		_shouldShow() {
			const timelineController = this.dashboardApi.getFeature('.StoryPaneService').timelineController;
			const episode = timelineController.getTimelineEpisodeById(this.content.getId());
			if(!episode) {
				return false;
			} else {
				return !BrowserUtils.isIE11() && !episode.touchesStart();
			}
		}

		_getRevealPropertiesList() {
			if(this._getVisType() === 'Line') {
				return [{
					id: 'effect.entry.line.type',
					editor: {
						sectionId: 'animation.propAniTypeDataEntrance',
						hidden: false,
						position: 1
					}
				},
				{
					id: 'effect.entry.line.stagger',
					editor: {
						sectionId: 'animation.propAniTypeDataEntrance',
						hidden: false,
						position: 2
					}
				},
				{
					id: 'effect.entry.line.duration',
					editor: {
						sectionId: 'animation.propAniTypeDataEntrance',
						hidden: false,
						position: 3,
						uiControl: {
							decimalPlaces: 2,
							label: this.stringResources.get('propAniRevealDuration'),
							ariaLabel: this.stringResources.get('propAniRevealDuration')
						}
					}
				}];
			} else {
				return [{
					id: 'effect.entry.bar.type',
					editor: {
						sectionId: 'animation.propAniTypeDataEntrance',
						hidden: false,
						position: 1
					}
				},
				{
					id: 'effect.entry.bar.stagger',
					editor: {
						sectionId: 'animation.propAniTypeDataEntrance',
						hidden: false,
						position: 2
					}
				},
				{
					id: 'effect.entry.bar.duration',
					editor: {
						sectionId: 'animation.propAniTypeDataEntrance',
						hidden: false,
						position: 3,
						uiControl: {
							decimalPlaces: 2,
							label: this.stringResources.get('propAniRevealDuration'),
							ariaLabel: this.stringResources.get('propAniRevealDuration')
						}
					}
				}];
			}
		}

	}

	return RevealPropertiesProvider;

});
